import script from "./TagsBlockSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagsBlockSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./TagsBlockSkeleton.vue?vue&type=style&index=0&id=c8dc210a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8dc210a"]])

export default __exports__